<ng-template #resultsWaiting>
  <app-waiting></app-waiting>
</ng-template>

<ng-container *ngIf="!isLoading; else resultsWaiting">
  <form class="f-col blank-form" [formGroup]="branchForm" (ngSubmit)="onSubmit()">
    <div class="section-heading">
      <h2 class="h2-heading">
        {{ content?.["b2b.managecompany.emaildomainlist"]?.[2]?.Phrase}}
        <div class="dot">.</div>
        <span class="optional"> {{content?.["b2b.managecompany.optional"]}}</span>
      </h2>
      <!-- <a class="add-new-link" *ngIf="tableData.length != 0" (click)="addNewDivision()">
      <span class="plus-icon">+</span> Add new
    </a> -->
      <a role="button" tabindex="0" class="link" *ngIf="tableData.length > 0 && !Addnew"
        (click)="addNewBranch()"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">add</mat-icon>{{ content?.["b2b.managecompany.addnew"]}}</a>
    </div>

    <!-- <app-cam-empty-state></app-cam-empty-state> -->

    <div class="section-content cm-branch-add-form" *ngIf="Addnew">
      <div class="inner-contentsection">
        <mat-accordion class="mat-accordion cam_accordion">
          <mat-expansion-panel [expanded]="Addnew" class="overflow-visible">
        
              <mat-panel-title>
                <h4 class="subheading">{{content?.["b2b.managecompany.officelocationdetail"]}}</h4>
              </mat-panel-title>
      
            <div class="mat-panel-body-custom ng-star-inserted">
              <div class="f-col info-section-wrapper" formGroupName="branchDetails">
                <div class="f-row">
                  <div class="f-col">
                    <div class="f-row validation-col">
                      <label class="mat-label">{{
                        content?.["b2b.managecompany.status"]
                        }}</label>
                      <mat-radio-group aria-label="Select an option" formControlName="status">
                        <mat-radio-button [value]="true">{{
                          content?.["b2b.managecompany.active"]
                          }}</mat-radio-button>
                        <mat-radio-button [value]="false">{{
                          content?.["b2b.managecompany.deactivate"]
                          }}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>

                <div class="f-row two--ColLayout">




                  <div class="f-col">
                    <mat-form-field>
                      <mat-label>{{content?.["b2b.managecompany.officelocationname"]}}</mat-label>
                      <input matInput formControlName="corporateBranchName" (keypress)="blockInvalidCharacters1($event)"
                        (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.corporateBranchName')
                            .hasError('minlength')
                        ">
                       {{ dictionaryContent?.["b2b.managecompany.officelocationminlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.corporateBranchName')
                            .hasError('maxlength')
                        ">
                       {{dictionaryContent?.["b2b.managecompany.officelocationmaxlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.corporateBranchName')
                            .hasError('required')
                        ">
                       
                       
                      </mat-error>
                    </mat-form-field>                   
                  </div>

                  <div class="f-col">
                     <mat-form-field>
                      <mat-label>{{content?.["b2b.managecompany.officelocationcode"]}} </mat-label>
                      <input matInput formControlName="branchCode" (keypress)="_CommonService.blockSpecialChar($event)"
                        (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.branchCode')
                            .hasError('required')
                        ">
                         {{dictionaryContent?.["b2b.managecompany.officelocationrequired"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.branchCode')
                            .hasError('minlength')
                        ">
                       {{dictionaryContent?.["b2b.managecompany.officelocationcodeminlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.branchCode')
                            .hasError('maxlength')
                        ">
                       {{dictionaryContent?.["b2b.managecompany.officelocationcodemaxlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.branchCode')
                            .hasError('pattern')
                        ">
                         {{dictionaryContent?.["b2b.managecompany.officelocationcodenumeric"]}}
                      </mat-error>
                    </mat-form-field>
                    
                  </div>
                </div>

                <div class="f-row two--ColLayout">
                  <div class="f-col">
                    <mat-form-field>
                      <mat-label>{{content?.["b2b.managecompany.alternateofficelocationcode"] || 'Alternate Office location Code (Optional)'}}</mat-label>
                      <input matInput formControlName="alternateBranchCode" (keypress)="blockInvalidCharacters($event)"
                        (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.alternateBranchCode')
                            .hasError('minlength')
                        ">
                        {{dictionaryContent?.["b2b.managecompany.alternateolcminlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.alternateBranchCode')
                            .hasError('maxlength')
                        ">
                        {{dictionaryContent?.["b2b.managecompany.alternateolcmaxlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.alternateBranchCode')
                            .hasError('pattern')
                        ">
                         {{dictionaryContent?.["b2b.managecompany.alternateolcnumeric"]}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="f-col">
                    
                    <mat-form-field [class.mat-has-not-value]="
                        !branchForm.value.branchDetails.branchEmailAddress
                      ">
                      <mat-label>Office location Email Address</mat-label>
                      <input matInput formControlName="branchEmailAddress" (keypress)="blockexceptAttheRate($event)"
                        (keypress)="Onlyrs($event)" (paste)="onPasteBlocked($event)"
                        (contextmenu)="disableRightClick($event)" data-dd-privacy="mask" />
                      <mat-icon fontSet="material-symbols-outlined" matSuffix>mail</mat-icon>

                         <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.branchEmailAddress')
                            .hasError('required')
                        ">
                        {{content?.["b2b.managecompany.officelocationemail"] || 'Office location Email Address is required.'}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.branchEmailAddress')
                            ?.hasError('email')
                        ">
                        {{dictionaryContent?.["b2b.managetraveler.entervalidemail"] || 'Please enter a valid email address.'}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.branchEmailAddress')
                            ?.hasError('maxlength')
                        ">
                        {{dictionaryContent?.["b2b.managecompany.cannotexceedemailadd"]}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="f-row two--ColLayout">
                  <div class="f-col">
                    
                    <mat-form-field>
                      <mat-label>{{content?.['b2b.managetraveler.streetaddress'] || 'Street Address'}} </mat-label>
                      <input matInput formControlName="streetAddress" (paste)="onPasteBlocked($event)"
                        (contextmenu)="disableRightClick($event)" (keypress)="blockForAddress($event)" data-dd-privacy="mask" />

                          <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.streetAddress')
                            .hasError('required')
                        ">
                        {{dictionaryContent?.["b2b.managetraveler.streetaddreq"] || 'Street Address is required.'}}
                      </mat-error>

                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.streetAddress')
                            ?.hasError('minlength')
                        ">
                        {{dictionaryContent?.["b2b.managecompany.streetaddress.minlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.streetAddress')
                            ?.hasError('maxlength')
                        ">
                        {{dictionaryContent?.["b2b.managecompany.streetaddessmaxlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.streetAddress')
                            .hasError('pattern')
                        ">
                       {{dictionaryContent?.["b2b.managecompany.streetaddnospecialchar"]}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  
                  <div class="f-col">
                    <ng-select [items]="countriesLists" groupBy="group"
                      [searchFn]="_CommonService.customCountrySearchFn" (change)="filterCountries($event, 'city')"
                      formControlName="countryRegion" bindValue="isoCode" [placeholder]="
                        content?.['b2b.managecompany.countryorregion']
                      " (contextmenu)="_CommonService.disableRightClick($event)"
                      (paste)="_CommonService.onPasteBlocked($event)"
                      (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask">
                      <ng-template ng-optgroup-tmp let-item="item">
                        {{ item.group }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span class="ng-option-label">
                          <ng-container *ngIf="!!item?.newFlag?.src">
                            <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}"
                              class="flag-img" [height]="item.height" [width]="item.width" />
                          </ng-container>
                          {{ item.countryName }}
                        </span>
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item">
                        <span class="ng-value-label">
                          {{ item?.countryName }}
                        </span>
                      </ng-template>
                      <ng-template ng-notfound-tmp>
                        <div class="no-items-found">
                          <img src="../../../../../assets/images/not-found.png" alt="No items found"
                            class="no-items-image" />
                          <p>{{dictionaryContent?.["b2b.managetraveler.nocountryfound"]}}</p>
                        </div>
                      </ng-template>
                    </ng-select>
                    <mat-error class="px-4" *ngIf="
                        branchForm.get('branchDetails.countryRegion')
                          ?.invalid &&
                        branchForm.get('branchDetails.countryRegion')?.touched
                      ">
                      {{content?.["b2b.managecompany.selectcountry"] || 'Please select a country'}}
                    </mat-error>
                    <mat-error class="px-4" *ngIf="
                        branchForm
                          .get('branchDetails.countryRegion')
                          ?.hasError('noHtmlTagsValidator')
                      ">
                     {{dictionaryContent?.["b2b.register.entervalidinput"]}}
                    </mat-error>
                    <mat-error class="px-4" *ngIf="
                        branchForm
                          .get('branchDetails.countryRegion')
                          ?.hasError('InvalidInput')
                      ">
                       {{dictionaryContent?.["b2b.register.entervalidinput"]}}
                    </mat-error>
                  </div>
                  
                </div>

                <div class="f-row two--ColLayout">
                  <div class="f-col">
                    <mat-form-field>
                      <mat-label>{{
                        content?.["b2b.managecompany.state"]
                        }}</mat-label>
                      <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                      <mat-select formControlName="state" [disabled]="true" data-dd-privacy="mask">
                        <!-- <mat-option>+91</mat-option>
                      <mat-option>+966</mat-option>
                      <mat-option>+61</mat-option> -->
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="f-col">

                    <ng-select [items]="commonObjPipes.city.pipe" formControlName="city" bindLabel="cityName"
                      bindValue="cityName" [placeholder]="content?.['b2b.managecompany.city']"
                      (contextmenu)="_CommonService.disableRightClick($event)"
                      (paste)="_CommonService.onPasteBlocked($event)"
                      (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask">
                      <ng-template ng-notfound-tmp>
                        <div class="no-items-found">
                          <img src="../../../../../assets/images/not-found.png" alt="No items found"
                            class="no-items-image" />
                          <p>{{content?.["b2b.managecompany.nocityfound"] || 'No city found'}}</p>
                        </div>
                      </ng-template>
                    </ng-select>
                    <mat-error class="px-4" *ngIf="
                        branchForm.get('branchDetails.city').invalid &&
                        branchForm.get('branchDetails.city')?.touched
                      ">
                      {{dictionaryContent?.["b2b.managetraveler.selectcity"]}}
                    </mat-error>
                  </div>

                  
                </div>

                <div class="f-row two--ColLayout">                  
                  <div class="f-col">
                    <mat-form-field [class.mat-has-not-value]="
                        !branchForm.value.branchDetails.telephone
                      ">
                      <mat-label>{{
                        content?.["b2b.managecompany.telephone"]
                        }}</mat-label>
                      <input matInput formControlName="telephone" (keypress)="blockForTelephone($event)"
                        (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" data-dd-privacy="mask" />
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.telephone')
                            .hasError('minlength')
                        ">
                        {{dictionaryContent?.["b2b.managecompany.telephonenumberminlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.telephone')
                            .hasError('maxlength')
                        ">
                       {{dictionaryContent?.["b2b.managecompany.telephonenumbermaxlimit"]}}
                      </mat-error>
                      <!-- <mat-error *ngIf="branchForm.get('branchDetails.telephone').hasError('pattern') ">
                      Telephone number must be numeric.
                    </mat-error> -->
                      <mat-icon fontSet="material-symbols-outlined" matSuffix>call</mat-icon>
                    </mat-form-field>
                  </div>

                  <div class="f-col">
                    <mat-form-field>
                      <mat-label>{{
                        content?.["b2b.managecompany.phoneno"]
                        }}</mat-label>
                      <input matInput formControlName="mobileNumber" (keypress)="blockInvalidCharacters($event)"
                        (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)"
                        (keypress)="allowedNumberOnly($event)" data-dd-privacy="mask" />
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.mobileNumber')
                            .hasError('required')
                        ">
                        {{dictionaryContent?.["b2b.managecompany.phonenumberrequired"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.mobileNumber')
                            .hasError('maxlength')
                        ">
                      {{dictionaryContent?.['b2b.managecompany.cannotexceedmobilenumber']}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.mobileNumber')
                            .hasError('minlength')
                        ">
                       {{dictionaryContent?.['b2b.managecompany.cannotexceedmobilenumber']}}
                      </mat-error>
                      <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
                    </mat-form-field>
                  </div>
                </div>

                <div class="f-row two--ColLayout">
                  <div class="f-col">
                    <mat-form-field>
                      <mat-label>{{
                        content?.["b2b.managecompany.fax"]
                        }}</mat-label>
                      <input matInput formControlName="fax" (keypress)="blockForTelephone($event)"
                        (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" data-dd-privacy="mask" />
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.fax')
                            .hasError('minlength')
                        ">
                        {{dictionaryContent?.["b2b.managecompany.faxnumber7digit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.fax')
                            .hasError('maxlength')
                        ">
                         {{dictionaryContent?.["b2b.managecompany.faxnumbermaxlimit"]}}
                      </mat-error>
                      <!-- <mat-error *ngIf="branchForm.get('branchDetails.fax').hasError('pattern') ">
                      Fax Number must be numeric.
                    </mat-error> -->
                    </mat-form-field>
                  </div>

                  <div class="f-col">
                    <mat-form-field>
                      <mat-label>{{
                        content?.["b2b.managecompany.postalcodeopt"]
                        }}</mat-label>
                      <input matInput formControlName="postalCode" (keypress)="
                          _CommonService.blockInvalidCharacters($event)
                        " (paste)="_CommonService.onPasteBlocked($event)"
                        (contextmenu)="_CommonService.disableRightClick($event)" data-dd-privacy="mask" />

                      <!-- <mat-error *ngIf="branchForm.get('branchDetails.postalCode').hasError('pattern')"> Postal code cannot exceed 12 characters. </mat-error> -->
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.postalCode')
                            .hasError('maxlength')
                        ">
                        {{dictionaryContent?.["b2b.managecompany.postalcodemaxlimit"]}}
                      </mat-error>
                      <mat-error *ngIf="
                          branchForm
                            .get('branchDetails.postalCode')
                            .hasError('minlength')
                        ">
                       {{dictionaryContent?.["b2b.managecompany.postalcodeminlimit"]}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <div class="inner-action">
        <button mat-button class="button--secondary-small" (click)="onCancel()">
          {{ content?.["b2b.managecompany.cancel"] }}
        </button>
        <button mat-button class="button--primary-small no-focus" [class.disabled]="branchForm.invalid">
          {{ content?.["b2b.managecompany.save"] }}
        </button>
      </div>
    </div>

    <div class="section-table data-listing" *ngIf="tableData.length > 0 && !Addnew">
      <table mat-table [dataSource]="tableData" class="mat-elevation-z0">
        <!-- Position Column -->
        <ng-container matColumnDef="Branch">
          <th mat-header-cell *matHeaderCellDef>
            {{ content?.["b2b.managecompany.emaildomainlist"][2]?.Phrase }}
          </th>
          <td mat-cell *matCellDef="let element" data-dd-privacy="mask">
            {{ element.corpBranchName }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="Division">
          <th mat-header-cell *matHeaderCellDef>
            {{ content?.["b2b.managecompany.division"] }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.businessTypeName || "-" }}
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="City">
          <th mat-header-cell *matHeaderCellDef>
            {{ content?.["b2b.managecompany.city"] }}
          </th>
          <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.cityName }}</td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="Email Address">
          <th mat-header-cell *matHeaderCellDef>
            {{ content?.["b2b.managecompany.emailaddress"] }}
          </th>
          <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.emailAddress }}</td>
        </ng-container>

        <ng-container matColumnDef="Phone Number">
          <th mat-header-cell *matHeaderCellDef>
            {{ content?.["b2b.managecompany.phoneno"] }}
          </th>
          <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.phoneNo }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef>
            {{ content?.["b2b.managecompany.ddstatus"] }}
          </th>
          <td mat-cell *matCellDef="let element" class="status-tag">
            <span [ngClass]="element.status ? 'status-active' : 'status-inactive'">
              {{ element.status ? (content?.["b2b.managecompany.active"]) :  (content?.["b2b.managecompany.deactivate"]) }}
            </span>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <!-- <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <button mat-button color="primary" (click)="onEdit(element)">Edit</button>
          <button mat-button color="warn" (click)="onRemove(element)">Remove</button>
        </td>
      </ng-container> -->

        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef>
            {{ content?.["b2b.managecompany.ddactions"] }}
          </th>
          <td mat-cell *matCellDef="let element" class="onclick-links">
            <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">Edit</a> -->
            <a class="onclick-cell primary-link" tabindex="0" role="button" aria-label="edit" (keydown.enter)="onEdit(element)" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">edit</mat-icon></a>
            <!-- <a class="onclick-cell warm-link" (click)="onRemove(element)">Remove</a> -->
            <a class="onclick-cell warm-link" tabindex="0" role="button" aria-label="edit" (keydown.enter)="onRemove(element)" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">delete</mat-icon></a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <ng-container *ngIf="!isLoading && tableData.length == 0 && !Addnew">
      <app-cam-empty-state (myEvent)="handleEvent($event)"
        [heading]="content?.['b2b.managecompany.binobranchaddedtitle']"
        [content]="content?.['b2b.managecompany.binobranchaddeddesc']"
        [navigateTo]="'/cam/company-management/branch-information'">
      </app-cam-empty-state>
    </ng-container>
  </form>
</ng-container>

<ng-template #selectionWarning>
  <div class="custom-dialog">
    <div class="d-justify-bw">
      <div class="custom-dialog__left">
        <div class="mat-dialog-title custom-dialog__title d-justify-bw">
          <h2 class="mat-dialog-title">{{content?.warningList[0]?.title}}</h2>
          <!-- <div class="custom-overlay-close">
            <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
          </div> -->
        </div>
        <mat-dialog-content class="custom-dialog__text">
          <div class="custom-dialog__description">
            Are you sure you want to remove this Office location?
          </div>
        </mat-dialog-content>
        <mat-dialog-actions>
          <div class="dialog-actions-right">
            <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">
              {{content?.warningList[0]?.cancelCTAText}}
            </button>
            <button class="button--primary-small" mat-button (click)="CloseDialog(true)">
              {{content?.warningList[0]?.confirmCTAText}}
            </button>
          </div>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>